import React from "react"; 
import InspectionOrders from "../inspections/inspection"
class ServiceRecordOrdersParent extends React.Component {
    render() {
        return <InspectionOrders type="ServiceRecordOrders" title={"Service Record Orders"}/>;
    }
}

export default ServiceRecordOrdersParent;